import React, {Component, Fragment} from 'react';
import {DateTime} from 'luxon';
import {LoadingIndicator} from '../../components/LoadingIndicator';
import {api, getData} from '../../util/api';
import {loadTextIntoData} from '../../util/txtFileLoader.js';
import {parseMOSData} from '../../util/MOSData.js';
import Broadcasts from '../../assets/json/sendungen.json';
import './WeatherBroadcast.scss';
import MapViewDefault from './components/MapViewDefault';
import {Header} from './components/Header';
import {WeatherBroadcastNavigation} from './components/WeatherBroadcastNavigation';
import {WeatherBroadcastOptions} from './components/WeatherBroadcastOptions';
import MapViewRBB from '../../modules/MapViewRBB';
import ExportModal from './components/ExportModal';

const footerText = `MeteoEffects ${new Date().getFullYear()}`;

const shouldUpdate = lastUpdatedMillis => {
  if (!lastUpdatedMillis) return true;
  const currentDate = DateTime.now();
  const lastUpdatedDate = DateTime.fromMillis(lastUpdatedMillis);
  return !(
    currentDate.year === lastUpdatedDate.year &&
    currentDate.month === lastUpdatedDate.month &&
    currentDate.day === lastUpdatedDate.day
  );
};

export default class WeatherBroadcast extends Component {
  constructor(props) {
    super(props);
    this.setMap = this.setMap.bind(this);
    this.setValueInMap = this.setValueInMap.bind(this);

    this.state = {
      map: false,
      data: false,
      parentData: false,
      broadcastTitle: '',
      broadcaster: '',
      open: false,
      filepath: props.filepath,
      error: false,
      moon: undefined,
      isMoonFetched: false
    };
    this.mapRef = React.createRef();
  }

  getMoonPhase = async () => {
    if (this.state.moon) return new Promise(() => this.state.moon);

    return fetch(api.moon)
      .then(res => res.json())
      .then(moonResponse => {
        if (!moonResponse)
          throw new Error('No response from moon phase endpoint.');
        return Number(moonResponse.moon);
      })
      .catch(e => {
        console.error(e);
        return undefined;
      })
      .finally(() => this.setState({isMoonFetched: true}));
  };

  handleOpen = () => {
    // this.lockItems();
    this.setState({
      open: true
    });
  };
  handleClose = () => {
    this.setState({
      open: false
    });
  };

  async loadRBB(data) {
    if (shouldUpdate(data.lastUpdated)) {
      data = await fetch(api.files.readTemplate('rbb_hbbtv.json')).then(r =>
        r.json()
      );
    }

    if (!data.error) {
      this.setState({
        broadcastTitle: data.title,
        broadcaster: data.broadcaster,
        data: data,
        parentData: data,
        map: data.maps[Object.keys(data.maps)[0]],
        error: false
      });
    } else {
      this.setState({error: data.error});
    }
  }

  async loadWDR(data) {
    if (shouldUpdate(data.lastUpdated)) {
      data = await loadTextIntoData(
        data,
        Broadcasts[this.state.filepath].forecast
      );
      data = await loadTextIntoData(
        data,
        Broadcasts[this.state.filepath].tendency
      );
    }

    if (!this.state.isMoonFetched) {
      this.getMoonPhase().then(moon => {
        if (!moon) return;
        data.maps['heute-nacht'].items.moonphase.data.iconIndex.value = moon;
        this.setState({moon, data});
      });
    }

    if (!data.error) {
      this.setState({
        broadcastTitle: data.title,
        broadcaster: data.broadcaster,
        data: data,
        parentData: false,
        map: data.maps[Object.keys(data.maps)[0]],
        error: false
      });
    } else {
      this.setState({error: data.error});
    }
  }

  async loadBR(data) {
    let parentData = data;
    if (this.state.filepath !== 'br_rundschau.json') {
      parentData = await getData('br_rundschau.json');
    }
    if (shouldUpdate(data.lastUpdated)) {
      data = await parseMOSData(data, Broadcasts[this.state.filepath].forecast);
    }

    if (!data.error) {
      this.setState({
        broadcastTitle: data.title,
        broadcaster: data.broadcaster,
        data: data,
        parentData: parentData,
        map: data.maps[Object.keys(data.maps)[0]],
        error: false
      });
    } else {
      this.setState({error: data.error});
    }
  }

  async loadArd(data) {
    // if (shouldUpdate(data.lastUpdated)) {
    //   data = await fetch(api.files.readTemplate('rbb_hbbtv.json')).then(r =>
    //     r.json()
    //   );
    // }

    if (!data.error) {
      this.setState({
        broadcastTitle: data.title,
        broadcaster: data.broadcaster,
        data: data,
        parentData: data,
        map: data.maps[Object.keys(data.maps)[0]],
        error: false
      });
    } else {
      this.setState({error: data.error});
    }
  }

  async componentDidMount() {
    let data = await getData(this.state.filepath);
    if (data.broadcaster === 'BR') {
      await this.loadBR(data);
    } else if (data.broadcaster === 'RBB') {
      await this.loadRBB(data);
    } else if (data.broadcaster === 'ARD') {
      await this.loadArd(data);
    } else {
      await this.loadWDR(data);
    }
  }

  setMap(mapIdx) {
    this.setState({
      map: this.state.data.maps[mapIdx],
      logMessage: ''
    });
  }

  setValueInMap(item, newData) {
    if (
      Object.values(newData)[0].value.toString() === 'NaN' ||
      Object.values(newData)[0].value.toString() === ''
    ) {
      Object.values(newData)[0].value = 0;
    }

    let newMap = {...this.state}.map;
    let mapItems = newMap.items;
    let oldData = mapItems[item.id].data;

    const lastUpdate = Math.floor(Date.now() / 1000);
    Object.keys(newData).map(key => (newData[key].lastUpdate = lastUpdate));

    mapItems[item.id].data = {...oldData, ...newData};
    this.setState({map: newMap});
  }

  lockItems() {
    this.mapRef.current.childFunction1();
  }

  render() {
    return (
      <div className='weatherbroadcast-body'>
        <Header title={this.state.broadcastTitle} />
        <div className='weatherbroadcast-content'>
          {this.state.map ? (
            <Fragment>
              <div className='left-wrapper'>
                <WeatherBroadcastNavigation
                  data={this.state.data}
                  setMap={this.setMap}
                />
                {this.state.broadcaster !== 'RBB' ? (
                  <MapViewDefault
                    map={this.state.map}
                    data={this.state.data}
                    parentData={this.state.parentData}
                    broadcaster={this.state.broadcaster}
                    setValueInMap={this.setValueInMap}
                  />
                ) : (
                  <Fragment>
                    <MapViewRBB
                      map={this.state.map}
                      mapRef={this.mapRef}
                      data={this.state.data}
                      parentData={this.state.parentData}
                      broadcaster={this.state.broadcaster}
                      setValueInMap={this.setValueInMap}
                      lockItems={this.lockItems}
                      unlockItems={this.unlockItems}
                    />
                    <ExportModal
                      open={this.state.open}
                      handleClose={this.handleClose}
                      map={this.state.map}
                      data={this.state.data}
                      parentData={this.state.parentData}
                      broadcaster={this.state.broadcaster}
                      renderView={true}
                      setValueInMap={this.setValueInMap}
                    />
                  </Fragment>
                )}
              </div>
              <div className='right-wrap'>
                <WeatherBroadcastOptions
                  filepath={this.state.filepath}
                  data={this.state.data}
                  map={this.state.map}
                  handleOpen={this.handleOpen}
                />
              </div>
            </Fragment>
          ) : (
            <LoadingIndicator error={this.state.error} />
          )}
        </div>

        <div className='footer' style={{backgroundColor: '#f1f2f3'}}>
          {footerText}
        </div>
      </div>
    );
  }
}
